module.exports = __webpack_public_path__ + "img/zz16.5e99691e.png";